import React, { FC } from 'react';
import styled from '@emotion/styled';
import PersonIcon from '~Assets/icons/person.svg';
import Icon from '~ComponentsImproved/Icon';

const Wrapper = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  top: 4px;
  font-size: 8px;
  line-height: 1.2;
  word-break: break-word;
  padding: 0 2px;
`;

/** Component floating in absolute on chequeitem to indicate that a member has been linked to the cheque */
const Member: FC = () => {
  return (
    <Wrapper>
      <Icon color="var(--colorBlueGray800)" height="16px" width="16px" src={PersonIcon} />
    </Wrapper>
  );
};

export default Member;
